<button
  mat-icon-button
  [color]="hasFilters() ? 'primary' : ''"
  [matMenuTriggerFor]="aftaleFilter"
  matTooltip="Brug filtre"
  [matBadge]="filterCount()"
  matBadgeSize="small"
  [matBadgeHidden]="filterCount() === 0"
  [disabled]="isLoading"
  [disableRipple]="true"
  >
  <mat-icon svgIcon="filter"></mat-icon>
</button>
<mat-menu #aftaleFilter="matMenu">
  @if (hasFilters()) {
    <button (click)="reset()" title="Fjern alle filtre" class="btn-icon red">
      <mat-icon svgIcon="delete"></mat-icon>
      <span>Fjern alle filtre</span>
    </button>
    <hr />
  }
  @for (product of products; track product) {
    <div (click)="$event.stopPropagation()">
      <mat-slide-toggle [checked]="isProductChecked(product.id)" color="primary" (change)="onProductToggle(product.id)">
        <mat-icon [svgIcon]="product.text.toLowerCase()" [matTooltip]="product.text | titlecase"></mat-icon>
        <span>{{ product.text }}</span>
      </mat-slide-toggle>
    </div>
  }
  <hr />
  @for (state of states; track state) {
    <div (click)="$event.stopPropagation()">
      <mat-slide-toggle [checked]="isStateChecked(state.state)" color="primary" (change)="onStateToggle(state.state)">
        {{ state.text }}
      </mat-slide-toggle>
    </div>
  }
  <hr />
  <div (click)="$event.stopPropagation()">
    <app-partner-filter [partners]="partners" [filter]="filter" (partnerChange)="onPartnerChange($event)"></app-partner-filter>
  </div>
</mat-menu>
